import { Button, Grid } from '@material-ui/core'
import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, withRouter } from 'react-router'
import styled from 'styled-components'
import Loading from '../Loading'
import { ERROR, LOADING, LOADING_OFF } from '../store/actions/UserAction'
import Detail from './Detail'
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core';
import { lightGreen } from '@material-ui/core/colors';
const greenTheme = createMuiTheme({ palette: { primary: lightGreen } })

const Div = styled.div`
    margin-bottom: 5rem;
    margin-top: 1.5rem;

    @media (min-width: ${props => props.theme.mobileBreakpoint}){
        margin-top: 3rem;
    }
`

const Event = () => {

    const dispatch = useDispatch()
    const [event, setEvent] = useState()
    const userInfo = useSelector(state => state.userInfo)

    let history = useHistory()

    const addHandler = (e) => {
        e.preventDefault()
        if (userInfo && userInfo.roles[0].role.name !== "MEMBER")
        history.push(`/event/post`)
    }

    const delay = (n) => {
        return new Promise((resolve) => {
            setTimeout(resolve,n*1000);
        });
    }

    useEffect( ()=> {
        const getEvents = async () => {
        dispatch({type: LOADING, payload: ''})
        await delay(.5)
        axios
            .get(`https://kzhao-club.herokuapp.com/events/events`)
            .then(res => {
                setEvent(res.data)
                dispatch({type: ERROR, payload: ''})
            })
            .catch(err => {
                dispatch({type: ERROR, payload: "That wasn't suppose to happen, try again"})
            })
            .finally(() => {
                dispatch({type: LOADING_OFF, payload: ''})
            })
        }
        getEvents()
    },[dispatch, history])

    return (
        <Div>
            <Grid container direction={"column"} spacing={10}>
                <Grid item><h4>Get Involved!</h4></Grid>
            </Grid>
            {!event ? <Loading/> :
                        (<>
                            {event ? event.sort((a,b) => new Date(a.date) - new Date(b.date)).map(e => <Detail info={e}/>) : <p></p>}
                        </>)
            }
            <Grid container direction={"column"} spacing={2} hidden={userInfo && userInfo.roles[0].role.name !== "MEMBER" ? '' : 'true'}>
                <Grid item></Grid> {/*line break*/}
                <Grid item>
                <MuiThemeProvider theme={greenTheme}>
                    <Button onClick={addHandler} variant="contained" color="primary">
                        Add Event
                    </Button>
                </MuiThemeProvider>
                </Grid>
            </Grid>
        </Div>
    )
}

export default withRouter(Event)